import { createSelector } from 'reselect';
import { showSelector } from 'ai/selectors/testTarget/prsRollout/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showPrsRolloutSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showPrsRolloutSelector };
